import React, { useEffect } from 'react';
import { AppConstants } from '../model/enums';

const RefreshComponent = () => {
  useEffect(() => {
    const intervalId = setInterval(() => {
      window.location.reload();  // Sayfayı yenile
    }, AppConstants.refreshInterval);  // 10 dakika (600.000 milisaniye)

    // Component unmount olduğunda intervali temizleyin
    return () => clearInterval(intervalId);
  }, []); // Boş bağımlılık dizisi ile sadece bir kez çalışır

  return (
    <div>
      <h1>Sayfanız {AppConstants.refreshInterval / 60000} dakikada bir yenileniyor!</h1>
      <p>Son yenileme: {new Date().toLocaleTimeString()}</p>
    </div>
  );
};

export default RefreshComponent;
